import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=5b871ebd&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=5b871ebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b871ebd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b871ebd')) {
      api.createRecord('5b871ebd', component.options)
    } else {
      api.reload('5b871ebd', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=5b871ebd&scoped=true&", function () {
      api.rerender('5b871ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8AcmlQw3fHX0p/JS/comp/SearchFilterTokens.vue"
export default component.exports